import { useTranslation } from 'react-i18next'
import { useCallback } from 'react'
import { useBefehlForm } from '../../../hooks'
import BefehlFormWrapper from '../Generic/BefehlFormWrapper'
import { BefehlFormProps } from '../Generic'
import Auftrag29_10Form from './Auftrag29_10Form'

import { Befehl29 } from '../../../models'
import Auftrag29_20Form from './Auftrag29_20Form'
import Auftrag29_30Form from './Auftrag29_30Form'
import { Befehl29FormData, createBefehl29FormValidationSchema } from './schema'
import {
  convertBefehl29FormDataToModel,
  convertModelToBefehl29FormData
} from './converters'

/**
 * Main form component for Befehl 29
 */
export default function Befehl29Form({
  befehl,
  onSubmit,
  readOnly = false,
  'data-testid': testId = 'befehl-29-form',
  activateEmptyFieldWarnings = false,
  displayHeaderOnly = false
}: Readonly<BefehlFormProps<Befehl29>>) {
  const { t } = useTranslation('ui-befehle')

  const formMethods = useBefehlForm<
    ReturnType<typeof createBefehl29FormValidationSchema>
  >({
    readOnly,
    activateEmptyFieldWarnings,
    schema: createBefehl29FormValidationSchema(),
    initialData: befehl ? convertModelToBefehl29FormData(befehl) : undefined
  })

  const handleSubmit = useCallback(
    (data: Befehl29FormData) => {
      const updatedBefehl = convertBefehl29FormDataToModel(
        data,
        befehl.frontendId
      )
      onSubmit(updatedBefehl)
    },
    [befehl.frontendId, onSubmit]
  )

  return (
    <BefehlFormWrapper<Befehl29FormData>
      befehlKennung="29"
      title={t('befehle.29.description')}
      formMethods={formMethods}
      onSubmit={handleSubmit}
      readOnly={readOnly}
      data-testid={`${testId}-wrapper`}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      displayHeaderOnly={displayHeaderOnly}
    >
      {/* Auftrag 29.10 */}
      <Auftrag29_10Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-29-10`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
      {/* Auftrag 29.20 */}

      <Auftrag29_20Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-29-20`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
      {/* Auftrag 29.30 */}

      <Auftrag29_30Form
        readOnly={readOnly}
        data-testid={`${testId}-auftrag-29-30`}
        activateEmptyFieldWarnings={activateEmptyFieldWarnings}
      />
    </BefehlFormWrapper>
  )
}
